// eslint-disable-next-line
import { BasicLayout, BlankLayout, PageView, RouteView, UserLayout, WarehouseLayout } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [{
  path: '/user',
  component: UserLayout,
  redirect: '/user/login',
  hidden: true,
  children: [{
    path: 'login',
    name: 'login',
    component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
  },
    {
      path: 'register',
      name: 'register',
      component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
    },
    {
      path: 'register-result',
      name: 'registerResult',
      component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
    }
  ]
},

  {
    path: '/test',
    component: BlankLayout,
    redirect: '/test/home',
    children: [{
      path: 'home',
      name: 'TestHome',
      component: () => import('@/views/Home')
    }]
  },

  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }
  ,
  {
    path: '/warehouse',
    component: WarehouseLayout,
    redirect: '/warehouse/warehouse-select',
    children: [
      {
        path: 'warehouse-select',
        name: 'warehouseSelect',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/WarehouseSelect')
      }
    ]
  },
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    redirect: '/settings/statistics',
    meta: {
      title: '首页'
    },
    children: [
      {
        path: '/settings',
        component: PageView,
        meta: {
          title: '通用功能',
          keepAlive: true
        },
        children: [
          {
            path: '/settings/person',
            name: 'person',
            meta: {
              title: '个人设置',
              keepAlive: true
            },
            component: () => import(/* webpackChunkName: "user" */ '@/views/user/PersonalSetting')
          },
          {
            path: '/settings/workLayout',
            name: 'workLayout',
            component: () => import('@/views/dashboard/workplace/WorkLayout'),
            redirect: '/settings/workLayout/menuSearch',
            meta: {
              title: '个人中心',
              keepAlive: true
            },
            children: [
              {
                path: '/settings/workLayout/menuSearch',
                name: 'menuSearch',
                component: () => import('../views/dashboard/workplace/MenuSearch'),
                meta: {
                  title: '个人中心(菜单搜索)'
                  // hiddenHeaderContent:true
                }
              },
              {
                path: '/settings/workLayout/recentView',
                name: 'recentView',
                component: () => import('../views/dashboard/workplace/RecentView'),
                meta: {
                  title: '个人中心(最近访问)'
                  // hiddenHeaderContent:true
                }
              }
            ]
          },
          {
            path: '/settings/inventoryQuery',
            name: 'inventoryQuery',
            meta: {
              title: '库存查询',
              keepAlive: true,
              hiddenHeaderContent: true
            },
            component: () => import(/* webpackChunkName: "user" */ '@/views/query/InventoryQuery')
          },
          {
            path: '/settings/statistics',
            name: 'statistics',
            meta: {
              title: '作业统计',
              keepAlive: true,
              hiddenHeaderContent: true
            },
            component: () => import(/* webpackChunkName: "user" */ '@/views/query/Statistics.vue')
          }
        ]
      }
    ]
  },
  //pda部分设置路由
  {
    path: '/pda',
    component: BlankLayout,
    children: [
      {
        path: '/pda',
        name: 'PdaLogin',
        component: () => import(/* webpackChunkName: "user" */ '@/pdaView/PdaLogin.vue')
      }
    ]
  },
  {
    path: '/pda/pdaIndex',
    name: 'PdaIndex',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/PdaIndex.vue')
  },
  {
    path: '/pda/inbound/inboundPutaway/InboundPutaway',
    name: 'GoodsShelf',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/inboundPutaway/InboundPutaway.vue')
  },
  {
    path: '/pda/outbound/picking/PickingHall',
    name: 'PickingHall',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/picking/PickingHall.vue')
  },
  {
    path: '/pda/outbound/picking/SpecialHall',
    name: 'SpecialHall',
    meta: { device: false, entire: false },
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/picking/SpecialHall.vue')
  },
  {
    path: '/pda/outbound/picking/CasePicking',
    name: 'CasePicking',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/picking/CasePicking.vue')
  },
  {
    path: '/pda/outbound/picking/EachPicking',
    name: 'EachPicking',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/picking/EachPicking.vue')
  },
  {
    path: '/pda/outbound/picking/Replenishing',
    name: 'Replenishing',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/picking/Replenishing.vue')
  },
  {
    path: '/pda/outbound/picking/SupervisionCode',
    name: 'SupervisionCode',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/picking/SupervisionCode.vue')
  },
  {
    path: '/pda/outbound/review/ReviewHall',
    name: 'ReviewHall',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/review/ReviewHall.vue')
  },
  {
    path: '/pda/outbound/review/StagingArea',
    name: 'StagingArea',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/review/StagingArea.vue')
  },
  {
    path: '/pda/combinePackage/CombinePackage',
    name: 'PackMerge',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/combinePackage/CombinePackage.vue')
  },
  {
    path: '/pda/pad/PadIndex',
    name: 'PadIndex',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/pad/PadIndex.vue')
  },
  {
    path: '/pda/pad/Binding',
    name: 'Binding',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/pad/Binding.vue')
  },
  {
    path: '/pda/pad/Picking',
    name: 'Picking',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/pad/Picking.vue')
  },
  {
    path: '/pda/Common',
    name: 'Common',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/Common.vue')
  },
  {
    path: '/pda/inbound/receipt/Receipt',
    name: 'Receipt',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/receipt/Receipt.vue')
  },
  {
    path: '/pda/inbound/inspect/Inspect',
    name: 'Inspect',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/inspect/Inspect.vue')
  },
  {
    path: '/pda/inbound/inspect/ReceiptDetails',
    name: 'ReceiptDetails',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/inspect/ReceiptDetails.vue')
  },
  {
    path: '/pda/inbound/receipt/ReceiptSupervisionCodeList',
    name: 'ReceiptSupervisionCodeList',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/receipt/ReceiptSupervisionCodeList.vue')
  },
  {
    path: '/pda/inbound/receipt/ReceiptSupervisionCode',
    name: 'ReceiptSupervisionCode',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/receipt/ReceiptSupervisionCode.vue')
  },
  {
    path: '/pda/inbound/receipt/AsnDetailList',
    name: 'AsnDetailList',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/receipt/AsnDetailList.vue')
  },
  {
    path: '/pda/inbound/containerInbound/ContainerInbound',
    name: 'ContainerInbound',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/containerInbound/ContainerInbound.vue')
  },
  {
    path: '/pda/outbound/container/ContainerOutbound',
    name: 'ContainerOutbound',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/container/ContainerOutbound.vue')
  },
  {
    path: '/pda/inbound/replenishmentShelf/ReplenishmentShelf',
    name: 'ReplenishmentShelf',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/inbound/replenishmentShelf/ReplenishmentShelf.vue')
  },
  {
    path: '/pda/outbound/packing/',
    name: 'ContainerReview',
    meta: { positionType: { id: '227620358585573312', name: '中药打包' }, device: true, entire: false },
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/packing/ContainerReview.vue')
  },
  {
    path: '/pda/outbound/packing/',
    name: 'PickingOrderReview',
    meta: { device: false, entire: false },
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/packing/PickingOrderReview.vue')
  },
  {
    path: '/pda/outbound/packing/',
    name: 'ReviewOfPacking',
    component: () => import(/* webpackChunkName: "user" */ '@/pdaView/outbound/packing/ReviewOfPacking.vue')
  }
]

// 前端路由表
export const constantRouterComponents = {
  // 基础页面 layout 必须引入
  BasicLayout: BasicLayout,
  BlankLayout: BlankLayout,
  RouteView: RouteView,
  PageView: PageView,

  // 你需要动态引入的页面组件
  //dashboard
  analysis: () => import('@/views/dashboard/WarehouseAnalysis'),
  visualization: () => import('@/views/dashboard/Visualization'),
  workplace: () => import('@/views/dashboard/Workplace'),
  monitor: () => import('@/views/dashboard/Monitor'),
  everydayData: () => import('@/views/dashboard/EverydayData'),
  agvPickingEfficiency: () => import('@/views/dashboard/PickingEfficiency'),
  agvReceiptDetails: () => import('@/views/dashboard/ReceiptDetails'),
  agvInventoryDetails: () => import('@/views/dashboard/InventoryDetails'),

  /*配置*/
  ConfigNavigation: () => import('@/views/config/ConfigNavigation.vue'),
  approveConfig: () => import('@/views/config/ApprovalConfig.vue'),
  inventoryStateConfig: () => import('@/views/config/InventoryStateConfig'),
  inventoryStateConvertConfig: () => import('@/views/config/InventoryStateSwitchConfig.vue'),
  orderTypeConfig: () => import('@/views/basedata/OrderTypeMaintain.vue'),
  seedingPositionConfig: () => import('@/views/config/SeedingPositionConfig.vue'),
  PackingPositionConfig: () => import('@/views/config/PackingPositionConfig.vue'),
  ValidConfig: () => import('@/views/config/validConfig/ValidConfig.vue'),
  menuMaintenance: () => import('@/views/config/menu_maintenance/MenuMaintenance'),
  dictionaryMaintenance: () => import('@/views/config/dictionary_maintenance/DictionaryMaintenance'),
  systemParametersConfig: () => import('@/views/config/parameter/SystemParametersConfig.vue'),
  lockingRoadWay: () => import('@/views/config/LockingRoadWay.vue'),
  lockingLayer: () => import('@/views/config/LockingLayer.vue'),
  RoleAuthority: () => import('@/views/config/role_authority/RoleAuthority'),
  PrintConfig: () => import('@/views/config/print/Print.vue'),
  SystemPrintConfig: () => import('@/views/config/print/SystemPrintConfig.vue'),

  //基础资料
  enterpriseDataMaintain: () => import('@/views/basedata/enterprise/EnterpriseBaseData.vue'),
  itemForBaseDataView: () => import('@/views/basedata/item/ItemBaseData.vue'),
  containerMaintain: () => import('@/views/basedata/ContainerMaintain.vue'),
  containerTypeMaintain: () => import('@/views/basedata/ContainerTypeMaintain.vue'),
  lotMaintainView: () => import('@/views/basedata/LotMaintain.vue'),
  baseDataImport: () => import('@/views/basedata_import/BaseDataImport'),
  customerBaseData: () => import('@/views/basedata/customer_basedata/CustomerBaseData.vue'),
  supplierBaseData: () => import('@/views/basedata/customer_basedata/SupplierBaseData.vue'),
  warehouseBaseData: () => import('@/views/basedata/warehouse/WarehouseBaseData.vue'),
  storerBaseData: () => import('@/views/basedata/storer_maintenance/StorerBaseData.vue'),
  employeeData: () => import('@/views/basedata/user/UserBaseData.vue'),
  vehicleMaintain: () => import('@/views/basedata/VehicleDataMaintain'),
  location: () => import('@/views/basedata/ofs/Location.vue'),
  product: () => import('@/views/basedata/ofs/Product'),
  employee: () => import('@/views/basedata/ofs/Employee.vue'),
  storageRoomData: () => import('@/views/basedata/storageroom/StorageRoomBaseData'),
  zoneData: () => import('@/views/basedata/zone/ZoneBaseData.vue'),
  locationData: () => import('@/views/basedata/location_maintenance/LocationTable.vue'),
  addressManagement: () => import('@/views/basedata/address/AddressManagement.vue'),

  // 入库模块
  purchaseOrderMake: () => import('@/views/inbound/purchase_order_make/PurchaseOrderMake'),
  asnMake: () => import('@/views/inbound/asn/Asn'),
  receiving: () => import('@/views/inbound/receipt/Receipt'),
  inspect: () => import('@/views/inbound/inspect/Inspect'),
  receiptPrint: () => import('@/views/inbound/receipt_print/ReceiptPrint.vue'),
  shelf: () => import('@/views/inbound/shelf/Shelf.vue'),
  receiptModify: () => import('@/views/inbound/modify/Modify.vue'),
  receiptClose: () => import('@/views/inbound/receiving_close/ReceivingClose.vue'),

  // 出库模块
  saleOrderMake: () => import('@/views/outbound/sale_order_make/SaleOrderMake'),
  shipmentDispatch: () => import('@/views/outbound/dispatch_order/ShipmentDispatch.vue'),
  // 指定货位、库存不足、快速订单
  appointDispatch: () => import('@/views/outbound/appoint_order/OrderAppoint.vue'),
  oneStepDispatch: () => import('@/views/outbound/one_step_order/OneStepOrder.vue'),
  insufficientInventory: () => import('@/views/outbound/suspended_order/SuspendedOrder'),
  shortableDispatch: () => import('@/views/outbound/shortable_order/ShortableDispatch.vue'),
  shortableReview: () => import('@/views/outbound/shortable_order/ShortableReview.vue'),
  //波次集货
  waveStage: () => import('@/views/outbound/wave_stage/WaveStage.vue'),
  //拣货

  //打包
  containerPacking: () => import('@/views/outbound/pack_template/ContainerPacking.vue'),
  packingPositionMonitor: () => import('@/views/outbound/packing_position_monitor/PackingPositionMonitor.vue'),

  //订单打包
  pickingOrderPacking: () => import('@/views/outbound/pack_template/PickingOrderPacking.vue'),
  //出库换箱
  outBoundBoxExchange: () => import('@/views/outbound/outbound_exchange/OutBoundBoxExchange'),
  //视觉分播
  viewSeeding: () => import('@/views/outbound/view_seeding/ViewSeeding'),

  //消息异常处理
  scheduleErrorHandle: () => import('@/views/outbound/ScheduleErrorHandle'),
  //随货同行单打印
  shipmentPrint: () => import('@/views/outbound/order_print/DeliverPrint'),
  //出库标签补打
  outBoundTagPrint: () => import('@/views/outbound/outBoundTag_Print/OutBoundTagPrint'),
  //波次打单
  wavePicking: () => import('@/views/outbound/wavePicking/wavePicking'),
  //快递复核扫描
  rapidReviewScan: () => import('@/views/outbound/rapidReviewScan/rapidReviewScan'),
  //单品自动扫描
  automaticPackingScanning: () => import('@/views/outbound/automaticPackingScanning/automaticPackingScanning'),
  //后置打单符合扫描
  orderReviewScanning: () => import('@/views/outbound/orderReviewScanning/orderReviewScanning'),
  //称重扫描
  weighingScanning: () => import('@/views/outbound/weighingScanning/weighingScanning'),
  //快递交接扫描
  expressHandoverScanning: () => import('@/views/outbound/expressHandoverScanning/expressHandoverScanning'),
  //快递转发信息
  expressForwardingInformation: () => import('@/views/outbound/expressForwardingInformation/expressForwardingInformation'),
  //快递转发扫描
  expressForwardingScan: () => import('@/views/outbound/expressForwardingScan/expressForwardingScan'),
  //快递转发扫描
  afterSalesInboundScan: () => import('@/views/inbound/afterSalesInboundScan/afterSalesInboundScan'),
  //补货
  ActiveReplenishment: () => import('@/views/warehouse_management/ActiveReplenishment.vue'),

  /*退货*/
  purchaseReturnExecution: () => import('@/views/outbound/purchase_return/PurchaseReturnExecution'),
  purchaseReturnReview: () => import('@/views/outbound/purchase_return/PurchaseReturnReview.vue'),
  SaleReturn: () => import('@/views/inbound/sale_return/SaleReturn.vue'),

  /*质量控制*/
  inventoryStatusChange: () => import('@/views/quality_control/InventoryStatusChange'),
  disqualificationApply: () => import('@/views/quality_control/disqualification_manage/DisqualificationApply'),
  disqualificationConfirm: () => import('@/views/quality_control/disqualification_manage/disqualification_confirm/DisqualificationConfirm.vue'),
  disqualificationDestoryApply: () => import('@/views/quality_control/disqualification_manage/disqualification_destory_apply/DisqualificationDestoryApply.vue'),
  disqualificationDestoryConfirm: () => import('@/views/quality_control/disqualification_manage/disqualification_destory_confirm/DisqualificationDestoryConfirm.vue'),
  disqualificationQuery: () => import('@/views/quality_control/disqualification_manage/DisqualificationQuery.vue'),
  maintenancePlan: () => import('@/views/quality_control/maintenance/MaintenancePlan.vue'),
  maintenanceQuery: () => import('@/views/quality_control/maintenance/MaintenanceQuery.vue'),
  maintenanceConfig: () => import('@/views/quality_control/maintenance/config/MaintenanceConfig.vue'),
  /*库内管理*/
  deviceMonitor: () => import('@/views/warehouse_management/deive_monitor/DeviceMonitor.vue'),
  treasuryLocks: () => import('@/views/warehouse_management/inventory_lock/InventoryLock.vue'),
  /*移库管理*/
  AutomaticMoveOrder: () => import('@/views/warehouse_management/movebound/AutomaticMoveOrder'),
  CommonMoveOrder: () => import('@/views/warehouse_management/movebound/CommonMoveOrder'),
  LocationMoveOrder: () => import('@/views/warehouse_management/movebound/LocationMoveOrder'),
  TransferCommandPutaway: () => import('@/views/warehouse_management/movebound/TransferPutaway.vue'),
  /*盘点*/
  TemporaryCounting: () => import('@/views/counting/temporary_counting/TemporaryCounting.vue'),
  CountingApprove: () => import('@/views/counting/counting_approve/CountingApprove.vue'),
  inventoryPlan: () => import('@/views/counting/CountingPlan.vue'),
  //库存导入
  importInventory: () => import('@/views/warehouse_management/importInventory/importInventory.vue'),

  //配送
  deliveryLoading: () => import('@/views/delivery_manage/DeliveryLoading.vue'),
  deliveryArrange: () => import('@/views/delivery_manage/delivery_arrange/DeliveryArrange.vue'),
  deliveryIssue: () => import('@/views/delivery_manage/delivery_issue/DeliveryIssue.vue'),
  deliveryConfirm: () => import('@/views/delivery_manage/delivery_confirm/DeliveryConfirm.vue'),

  //查询
  dynamicQuery: () => import('@/views/admin/Query.vue'),
  formDesign: () => import('@/views/admin/FormDesign'),

  //订单查询
  purchaseOrderQuery: () => import('@/views/query/order_query/PurchaseOrderQuery.vue'),
  asnOrderQuery: () => import('@/views/query/order_query/AsnOrderQuery.vue'),
  receiptOrderQuery: () => import('@/views/query/order_query/ReceiptOrderQuery.vue'),
  saleOrderQuery: () => import('@/views/query/order_query/SaleOrderQuery.vue'),
  shipmentOrderQuery: () => import('@/views/query/order_query/ShipmentOrderQuery.vue'),
  loadingOrderQuery: () => import('@/views/query/order_query/LoadingOrderQuery.vue'),

  //指令查询
  receiptCommandQuery: () => import('@/views/query/command_query/ReceiptCommandQuery.vue'),
  shipmentCommandQuery: () => import('@/views/query/command_query/ShipmentCommandQuery.vue'),
  replenishCommandQuery: () => import('@/views/query/command_query/ReplenishCommandQuery.vue'),
  transferCommandQuery: () => import('@/views/query/command_query/TransferCommandQuery.vue'),
  containerCommandQuery: () => import('@/views/query/command_query/ContainerCommandQuery.vue'),

  //明细查询
  purchaseDetailQuery: () => import('@/views/query/detail_query/PurchaseDetailQuery.vue'),
  asnDetailQuery: () => import('@/views/query/detail_query/AsnDetailQuery.vue'),
  receiptDetailQuery: () => import('@/views/query/detail_query/ReceiptDetailQuery.vue'),
  inspectDetailQuery: () => import('@/views/query/detail_query/InspectDetailQuery.vue'),
  receiptRejectDetailQuery: () => import('@/views/query/detail_query/ReceiptRejectDetailQuery.vue'),
  inspectRejectDetailQuery: () => import('@/views/query/detail_query/InspectRejectDetailQuery.vue'),
  saleDetailQuery: () => import('@/views/query/detail_query/SaleDetailQuery.vue'),
  shipmentDetailQuery: () => import('@/views/query/detail_query/ShipmentDetailQuery.vue'),
  countingDetailQuery: () => import('@/views/query/detail_query/CountingDetailQuery.vue'),
  purchaseReturnDetailQuery: () => import('@/views/query/detail_query/PurchaseReturnDetailQuery.vue'),
  saleReturnDetailQuery: () => import('@/views/query/detail_query/SaleReturnDetailQuery.vue'),

  //库存查询
  inventoryQuery: () => import('@/views/query/InventoryQuery.vue'),
  ledgerQuery: () => import('@/views/query/LedgerQuery.vue'),
  balanceQuery: () => import('@/views/query/BalanceQuery.vue'),
  balanceStatistics: () => import('@/views/query/BalanceStatistics.vue'),
  locationUtilisation: () => import('@/views/query/LocationUtilisation.vue'),
  statistics: () => import('@/views/query/Statistics.vue')
}